export const prospectsKeys = {
  all: ["prospects"] as const,
  lists: () => [...prospectsKeys.all, "list"] as const,
  list: (filters: string) => [...prospectsKeys.lists(), { filters }] as const,
  details: () => [...prospectsKeys.all, "detail"] as const,
  detail: (prospect_guid: string | undefined) =>
    [...prospectsKeys.details(), prospect_guid] as const,
  prospectNotes: (prospect_guid: string) =>
    [...prospectsKeys.detail(prospect_guid), "notes"] as const,
  prospectContacts: (prospect_guid: string) =>
    [...prospectsKeys.detail(prospect_guid), "contacts"] as const,
  prospectPhoneNumbers: (prospect_guid: string) =>
    [...prospectsKeys.detail(prospect_guid), "phoneNumbers"] as const,
  prospectAccounts: (prospect_guid: string) =>
    [...prospectsKeys.detail(prospect_guid), "accounts"] as const,
  prospectEvents: (prospect_guid: string | undefined) =>
    [...prospectsKeys.detail(prospect_guid), "events"] as const,
  prospectPartialOrders: (prospect_guid: string) =>
    [...prospectsKeys.detail(prospect_guid), "partialOrders"] as const,
  prospectPartialShoppers: (prospect_guid: string) =>
    [...prospectsKeys.detail(prospect_guid), "partialShoppers"] as const,
  prospectShoppers: (prospect_guid: string) =>
    [...prospectsKeys.detail(prospect_guid), "shoppers"] as const,
}
